import { getPermissions } from "@/helper/collection";
import { authenticationService } from "@/services/AuthenticationService";

export const QrCodeRoutes = {
  path: "qr-code",
  name: "QrCode",
  redirect: "/qr-code",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "list-qr-codes",
      name: "qr page",
      component: () => import("@/components/Pages/viewListOfQrCodes.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          205,
          2
        )
      }
    },
    {
      path: "edit-qr-code",
      name: "qr page",
      component: () => import("@/components/Pages/editQrCode.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          205,
          2
        )
      }
    },
  ]
};



// WEBPACK FOOTER //
// ./src/router/qrCodeRoutes.js